import { FC } from 'react';

import { FormProvider } from 'react-hook-form';

import { ActionsProvider } from 'context/actions';
import { SaveProvider } from 'pages/audience/shared/save/context';
import { SaveProps } from 'types/pages/audience-builder/shared/save';

import { SaveAction, SaveButton, SaveSlideout } from './components';
import { useCreateForm } from './hooks';

const Save: FC<SaveProps> & { SaveAction: typeof SaveAction } = (props) => {
  const methods = useCreateForm();

  return (
    <FormProvider {...methods}>
      <SaveProvider>
        <ActionsProvider>
          <SaveButton {...props} />
          <SaveSlideout {...props} />
        </ActionsProvider>
      </SaveProvider>
    </FormProvider>
  );
};

Save.SaveAction = SaveAction;

export default Save;
